import { DisplayMedium, DisplaySmall } from "baseui/typography";
import React from "react";
import {
  HeaderNavigation,
  ALIGN,
  StyledNavigationList,
  StyledNavigationItem,
} from "baseui/header-navigation";
import { Link } from "react-router-dom";
import { StyledLink } from "baseui/link";


const Footer = () => {
  return (
    <footer>
      
          
     
              
    </footer>
  );
};

export default Footer;
